import React from "react";
import * as PropTypes from "prop-types";
import {Button, Modal} from "react-bootstrap";
import {FormField, InputLabel} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

export class RakutenBackToLogin extends React.Component {
    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>楽天ID連携ログインのセッションが切れました</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormField theme={this.props.theme}>
                    <InputLabel theme={this.props.theme}>ログイン画面で再度ログインし直してください。</InputLabel>
                </FormField>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={this.props.onClick}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>;
    }
}

RakutenBackToLogin.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    theme: PropTypes.any,
    onClick: PropTypes.func
};

export default RakutenBackToLogin;